<template>
  <div class="row">
    <div class="col-12">
      <el-table :data="comments">
        <el-table-column prop="id" label="ID" />
        <el-table-column prop="contentId" label="컨텐트 ID">
          <div slot-scope="props">
            <a href="javascript:void(0);" @click.stop="onClickContentId(props.row.contentId)">{{ props.row.contentId }}</a>
          </div>
        </el-table-column>
        <el-table-column label="작성자">
          <div slot-scope="props">
            <a href="javascript:void(0);" @click.stop="goToUserDetail(props.row.userId)">{{ props.row.nickname }}</a>
          </div>
        </el-table-column>
        <el-table-column prop="email" label="이메일" />
        <el-table-column prop="comment" label="내용" min-width="300" />
        <el-table-column :formatter="(row) => _f('formatDateTime')(row.regTime)" label="작성일시" />
        <el-table-column :formatter="(row) => _f('commentStateName')(row.state)" label="상태" />
        <el-table-column :min-width="135" align="center" label="삭제/복구">
          <div slot-scope="props">
            <base-button v-show="props.row.state === 1" @click.native="onClickDelete(props.$index, props.row)" class="btn-link" type="info" size="sm">
              삭제
            </base-button>
            <base-button v-show="props.row.state === 12" @click.native="onClickRestore(props.$index, props.row)" class="btn-link" type="info" size="sm">
              복구
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="pageCount"></base-pagination>
    </div>
  </div>
</template>

<script>
import { BasePagination } from "@/components/index";
import { Alert } from "@/util/Alert";
import { PathResolver } from "@/util/PathResolver";

export default {
  name: "CommentsTableView",
  components: {
    BasePagination,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  props: {
    namespace: {
      type: Number,
      required: true,
    },
    category: {
      type: String,
      required: false,
    },
    unitId: {
      type: Number,
      required: true,
    },
    comments: {
      type: Array,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
  },
  watch: {
    currentPage: function (newVal) {
      this.$emit("onPageChange", newVal);
    },
  },
  methods: {
    async onClickDelete(index, comment) {
      if (await Alert.dangerousConfirmCancel("댓글을 삭제하시겠습니까?", "댓글 작성자에게 알림 없이 삭제됩니다.")) {
        this.$emit("onDeleteConfirmed", comment.id);
      }
    },
    async onClickRestore(index, comment) {
      if (await Alert.dangerousConfirmCancel("댓글을 복원하시겠습니까?", "댓글 작성자에게 알림 없이 복원됩니다.")) {
        this.$emit("onRestoreConfirmed", comment.id);
      }
    },
    onClickContentId(contentId) {
      const nextPath = PathResolver.resolveContentDetailPath(this.namespace, this.unitId, contentId, this.category);
      console.log(nextPath);
      this.$router.push(nextPath);
    },
    goToUserDetail(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
  },
};
</script>
<style lang="scss"></style>
